import { checkForSubQuestion } from '../handlers/utils';

import { onSubmit } from '../handlers';
import { skipParse } from '../formSections/Parser/utils';

export const openProTip = (stateProps, protip) => {
  stateProps.setPTMessage(protip);
  stateProps.onPTOpen();
};
export const updatePreview = (e,props) => {
  alert (e.target.value);
}
export const clearResume = (e, form,field,props) => {

  form.setFieldValue(field.name, e.target.files[0]);
}
export const fileUploadChange = (e,form,field) => {
  form.setFieldValue(field.name, e.target.files[0]);
  const parseButton = document.querySelector('#parseButton');
  parseButton.style.backgroundColor='#ff914d';
}
export const closeProTip = (stateProps) => {
  stateProps.setPTMessage('');
  stateProps.onPTClose();
};
export const handleChange = (formikProps, stateProps, index, qObj, newValue) => {
  formikProps.values.jobSeekerData[index][qObj.qid] = newValue;
  onSubmit(formikProps, stateProps);
};
export const handleRadioButtonChange = (formikProps, stateProps, index, qObj, newValue ) => {
  if (stateProps.sectionData.sectionName === 'parser') {
    const parseRadioButton = document.querySelector('#P1');
    const parseButton = document.querySelector('#parseButton');
    if(newValue === 'no') {
//      onLink(false,formikProps,stateProps,'menu');
      skipParse(stateProps);
    }
    if(newValue === 'yes' ) {
      parseRadioButton.parentElement.style.display='none';
      parseButton.style.display='block';
    }
  }

if(!index) index=0;
  formikProps.values.jobSeekerData[index][qObj.qid] = newValue;
  onSubmit(formikProps, stateProps);
};
// set value to first option
export const setInitialRadioButtonValue = (props, qObj) => {
  const index = props.stateProps.editableIndex;//getResumeOrSectionIndex(props.stateProps,props.formikProps);

  if (typeof props.formikProps.values.jobSeekerData[index][qObj.qid] === 'undefined') {
    props.formikProps.values.jobSeekerData[index][qObj.qid] = qObj.options[0].value;
  }
};
export const getColumns = (qObj, questionParts) => {
  //One column per multipart question part.
  let columns = 0;
  questionParts.forEach((qPart) => {
    if (qPart.mpparent === qObj.qid) {
      columns++;
    }
  });
  //Manual override from question definition
  columns = typeof qObj.columns === 'undefined' ? columns : qObj.columns;
  return columns;
};
export const getQuestionParts = (props, qObj, index) => {
  const allQuestionParts = props.sections.question_parts;
  let questionParts = [];
  //ugh find alternative to map
  allQuestionParts.forEach((questionPart) => {
    if (typeof questionPart.mpparent !== 'undefined') {
      const mpparents = questionPart.mpparent.split(',');

      mpparents.forEach((mpparent) => {
        if (mpparent === qObj.qid) {
          if (questionPart.is_subquestion) {
            const found = checkForSubQuestion(questionPart, props, index);
            if (found) {
              questionParts.push(questionPart);
            }
          } else {
            questionParts.push(questionPart);
          }
        }
      });
    }
  });
  return questionParts;
};